import { connect } from "react-redux";
import TenantSignUp from "../components/SignUp/Tenant";
import { clearSignUpStatus, setSignUpEmail } from "../actions/signUpActions";
import { submit, reduxForm, getFormValues } from "redux-form";

const form = "signup";

function mapStateToProps(state) {
    return {
        signupState: state.signUp.status,
        reason: state.signUp.reason,
        email: state.signUp.email,
        formValues: getFormValues(form)(state),
        form,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
        manualSubmit: form => dispatch(submit(form)),
        clearSignUp: () => dispatch(clearSignUpStatus()),
        setEmail: email => dispatch(setSignUpEmail(email)),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(reduxForm({
    form,
    destroyOnUnmount: false
})(TenantSignUp));
